<template>
  <div class="container">
    <div class="" style="display: flex;flex-direction: row;align-items: center;margin-bottom: 10px;">
        <i class="el-icon-s-fold" ></i>
        <el-breadcrumb separator="/" >
          <el-breadcrumb-item >内容管理</el-breadcrumb-item>
          <el-breadcrumb-item class="bread" :to="{ path: '/manage/user/user-list' }">账号管理</el-breadcrumb-item>
          <el-breadcrumb-item >新增账号</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
    <div class="equip-add">
      <dv-border-box-12>
        <div style="padding: 6px 6px 8px 6px;">
          <div class="header-common">
            <div class="header-common-left">
              <div class="title">添加新账号</div>
            </div>
          </div>
          <el-form
            :model="form"
              label-width="100px"
              class="add-form"
              :rules="rules"
              ref="form">
              <el-form-item label="选择分组" prop="group">
                <el-input id="group" v-model="form.group" placeholder="所在分组" style="width: 50%;float: left;" readonly>
                </el-input>
                <el-button @click="showGroups" size='mini' style="margin-left: 10px;">选择分组</el-button>
                <!-- <el-select v-model="form.group" placeholder="点击选择分组"  @change="groupChange($event)" style="width: 50%;">
                  <el-option
                    v-for="item in groups"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code">
                  </el-option>
                </el-select> -->
              </el-form-item>
              <el-form-item label="账号名" prop="username" >
                <el-input id="username" v-model="form.username"  placeholder="英文数字组合" style="width: 50%;" ></el-input>
              </el-form-item>
              <el-form-item label="登录密码" prop="password" >
                <el-input id="password" v-model="form.password" style="width: 50%;"  placeholder="请输入密码"></el-input>
              </el-form-item>
              <el-form-item label="用户姓名" prop="nickname" >
                <el-input id="nickname" v-model="form.nickname" placeholder="请输入真实姓名" style="width: 50%;"></el-input>
              </el-form-item>
              <el-form-item label="手机号" prop="phone" >
                <el-input id="phone" v-model="form.phone" placeholder="请输入手机号" style="width: 50%;"></el-input>
              </el-form-item>
              <el-form-item style="margin-top: 40px;">
                <el-button class="action-button" type="primary"  @click="submitForm('form')">立即保存</el-button>
                <el-button class="action-button" @click="resetForm('form')">重置</el-button>
              </el-form-item>
            </el-form>
        </div>
      </dv-border-box-12>
    </div>

    <template>
    <!-- 分组列表 -->
      <el-dialog :visible.sync="showMoreGroups" title="分组列表">
        <el-table
          :data="groups"
          border
          style="width: 100%;"
          :max-height="400"
          @cell-click="chooseOneGroup"
          >
          <el-table-column
            type="index"
            label="序号">
          </el-table-column>
          <el-table-column
            prop="code"
            label="分组编码">
          </el-table-column>
          <el-table-column
            prop="name"
            label="分组名称">
          </el-table-column>
        </el-table>
      </el-dialog>

    </template>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        groups:[],
        form: {
          group: '',
          groupCode:'',
          username: '',//账号
          password:'',
          nickname:'',//真实姓名
          phone: '',
        },
        showMoreGroups:false,
        rules: {
          group: [{ required: true, message: '请选择分组', trigger: 'blur' }],
          username: [{ required: true, message: '请输入账户名称', trigger: 'blur' }],
          password: [{ required: true, message: '请输入登录密码', trigger: 'blur' }],
          phone: [{min: 11,max:11,message:'请输入11位手机号'}]
        },

      }
    },
    mounted() {
      this.getGroupList()
    },
    methods: {
      getGroupList(){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/accountgroup/list';
        this.$http({
          method:'GET',
          url:url,
          headers:headers
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              if(obj.data.groups){
                // 获取设备数据
                this.groups = obj.data.groups;
              }
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      groupChange(val){
        this.form.groupCode = val;
      },
      showGroups(){
        this.showMoreGroups = true
      },
      chooseOneGroup(row){
        this.form.groupCode = row.code;
        this.form.group = row.name;
        this.showMoreGroups = false
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.addAccount()
          } else {
            return false;
          }
        });
      },
      addAccount(){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/account/add';
        const data = {
          "groupCode": this.form.groupCode,
          "username": this.form.username,
          "password": this.form.password,
          "phone": this.form.phone,
          "nickname":this.form.nickname,
        }

        this.$http({
          method:'POST',
          url:url,
          headers:headers,
          data:data
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              this.$message({
                message:'添加成功',
                type:'success'
              })
              this.resetForm('form')
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      goBack(){
        this.$router.back()
      }
    },
  }
</script>


<style lang="scss" scoped>
  .container {
    height: 100%;
    margin-top: $header-height;

    .bread >>>.el-breadcrumb__inner{
      color: #606266;
      font-weight: 400;
    }

    .header-common{
      width: 100%;
      height: 45px;
      border-radius: 12px 12px 0 0 ;
      background: linear-gradient(-90deg, #001940, #1564BE);
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      .header-common-left{

        font-size: 20px;

        font-weight: bold;
        color: #FEFEFE;
        margin-left: 21px;
        .title{
          font-size: 20px;
          font-weight: bold;
          color: #FEFEFE;
        }
      }
    }


    .equip-add{

      .add-form{
        padding: 25px 5px 25px 0px;

        .btn{
          width: 240px;
          background-color: RGBA(17, 58, 113, 0.5);
          border: 2px solid #1D4BB6;
          border-radius: 6px;
          box-shadow: 2px 2px 0 0 rgba(0,0,0,0.2);
          caret-color: rgba(0,255,255,0.8);
          color: #FFFFFF;
          font-size: 15px;
          font-weight: 400;
          text-align: left;
        }

        // 选中前后的文字颜色
        .redbox .el-checkbox__input+.el-checkbox__label{
          color: rgba(255, 255, 255, 0.5);
        }
        .redbox .el-checkbox__input.is-checked+.el-checkbox__label{
          color: #FF8400;
        }

        //选中前后的边框颜色
        .redbox.is-bordered{
          border-color: rgba(255, 255, 255, 0.5);
        }
        .redbox.is-bordered.is-checked{
          border-color: #FF8400;
        }

        // 选中前后对勾框的边框和背景色
        .redbox .el-checkbox__input .el-checkbox__inner, .redbox .el-checkbox__input.is-indeterminate .el-checkbox__inner{
          border-color: #A5D5FF;
          background-color: rgba(255, 255, 255, 0.5);
        }
        .redbox .el-checkbox__input.is-checked .el-checkbox__inner, .redbox .el-checkbox__input.is-indeterminate .el-checkbox__inner{
          border-color: #FF8400;
          background-color: #FF8400;
        }
      }

      .content-add-user{
        float: left;
        border-radius: 3px;
      }
      .action-button{
          width: 120px;
          height: 40px;
          background: #FAFAFA;
          border: 1px solid rgba(0,144,255,0.84);
          border-radius: 20px;
          background-color: #20478D;
          font-size: 14px;
          font-weight: 400;
          color: #00DEFF;
      }
    }

    //表单验证错误提示偏移
    .el-form-item__error{
      // margin-top: -14px;
      top: 100%;
      padding-top: -30px;
    }

    .el-select .el-input .el-select__caret{
      //清除默认的select选择框样式
      // appearance: none;
      // -moz-appearance: none;
      // -webkit-appearance: none;
      // padding-right: 14px;//箭头位置
      // margin-top: 40px;
      color: red;
    }

    .el-icon-arrow-up:before{
      content: "";
    }

    // 下拉框位置
    .el-select-dropdown el-popper{
      position: absolute!important;
      top: 240px !important;
      left: 30px !important;
    }

    .el-checkbox-button__inner{
      background-color: #00DEFF;
    }


    .el-checkedbox__input.is-checked.el-checkbox__label{
      color: #FFFFFF;
    }

    .el-checkedbox__input
    {
      background-color: #00DEFF;
      color: brown;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/manage/user/user-add.vue